import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from './form-field.component';
import { InputDirective } from './input.directive';
import { FieldSuffixDirective } from './field-suffix.directive';
import { FieldLabelDirective } from './field-label.directive';
import { FieldPreffixDirective } from './field-preffix.directive';
import { FieldErrorDirective } from './field-error.directive';

@NgModule({
  declarations: [
    FormFieldComponent,
    InputDirective,
    FieldSuffixDirective,
    FieldPreffixDirective,
    FieldLabelDirective,
    FieldErrorDirective,
  ],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [
    FormFieldComponent,
    InputDirective,
    FieldSuffixDirective,
    FieldPreffixDirective,
    FieldLabelDirective,
    FieldErrorDirective,
  ],
})
export class FormFieldModule {}
